import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import ButtonDemo from './ButtonDemo';
import ClientProvider from './client';
export default createDemo(import.meta.url, ButtonDemo, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/integrations/routing/demos/button-demo/ButtonDemo.tsx",
    "fileName": "ButtonDemo.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import Button from '@mui/material/Button';\n\nexport default function ButtonDemo() {\n  return (\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 2,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    <Button href=\"/\" variant=\"contained\">\n      Link\n    </Button>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 9,
        "focusedLines": 3,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import Button from '@mui/material/Button';\n\nexport default function ButtonDemo() {\n  return (\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 2,
          "dataFrameFocusTarget": ""
        },
        "    <Button href=\"/\" variant=\"contained\">\n      Link\n    </Button>\n"
      ],
      [
        "span",
        "frame",
        "  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 2,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 5
            },
            [
              "    <",
              [
                "span",
                "pl-c1 di-jsx",
                "Button"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "href"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "/",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "variant"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "contained",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 6
            },
            "      Link"
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 7
            },
            [
              "    </",
              [
                "span",
                "pl-c1 di-jsx",
                "Button"
              ],
              ">"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 9,
    "focusedLines": 3,
    "collapsible": true,
    "externals": [
      "@mui/material/Button"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
